/**
 * Created by wuhuping on 2017/7/5.
 */
import Instance from './resource'
export default {
  // 公告列表
  fetchNoticeList(data) {
    return Instance.post('account/getNoticeInfo', data);
  },
  // 公告详情
  fetchNoticeDetail(data) {
    return Instance.post('account/readNotice', data);
  },
  // 常见问题列表
  fetchProblemList(data) {
    return Instance.post('system/getProblemTitle', data);
  },
  // 常见问题详情
  fetchProblemDetail(data) {
    return Instance.post('system/getProblemInfo', data);
  },
  // 校验动态验证码
  validateDynamicCode(data) {
    return Instance.post('user/checkImageCode', data);
  },
  // 预切换动态验证码
  preSwitchDynamicCode(data) {
    return Instance.post('user/preGetImageCode', data);
  },
  // 获取注册页面信息
  fetchRegisterPageInfo(data) {
    return Instance.post('system/getMsgInf', data);
  },
  // 获取广告页图片
  fetchAdPageInfo(data) {
    return Instance.post('system/showBanner', data);
  },
  // 获取banner页信息
  fetchBannerPageInfo(data) {
    return Instance.post('system/getMsgInf', data);
  },
  // 上传微信code
  uploadWxCode(data) {
    return Instance.post('account/sendWeixinCode', data);
  },
  // 获取系统提示信息
  fetchAlertInfo(data) {
    return Instance.post('system/getPopupNotice', data);
  },
  fetchKp(data) {
    return Instance.post('system/showBanner', data)
  },
  // 获取营销弹窗信息
  fetchPopupAdvertisement(data) {
    return Instance.post('prodJry/getPopupAdvertisement', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/system.js